module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "set-with-draw"
  }, [_c('div', {
    staticClass: "panle now-count-info"
  }, [_c('span', {
    staticClass: "tit"
  }, [_vm._v("\n            *提现前请先设置以下信息，填写错误导致的任何问题，本公司概不负责。请谨慎填写！\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "count-info"
  }, [_c('div', {
    staticClass: "item name"
  }, [_c('span', {
    staticClass: "item-name"
  }, [_vm._v("姓名:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请填写真实姓名"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item phone"
  }, [_c('span', {
    staticClass: "item-name"
  }, [_vm._v("手机号:")]), _vm._v(" "), ((_vm.dataInfo.username == '') || (_vm.dataInfo.username == null)) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请填写正确的手机号"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), ((_vm.dataInfo.username != null)) ? _c('span', {
    staticClass: "phone"
  }, [_vm._v(_vm._s(_vm.phone))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "item idcard"
  }, [_c('span', {
    staticClass: "item-name"
  }, [_vm._v("身份证:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.idCard),
      expression: "idCard"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请填写正确的身份证"
    },
    domProps: {
      "value": (_vm.idCard)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.idCard = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item card"
  }, [_c('span', {
    staticClass: "item-name"
  }, [_vm._v("银行卡:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.card),
      expression: "card"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请填写正确的银行卡号"
    },
    domProps: {
      "value": (_vm.card)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.card = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item bank"
  }, [_c('span', {
    staticClass: "item-name"
  }, [_vm._v("开户银行:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bank),
      expression: "bank"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请填写正确的开户银行"
    },
    domProps: {
      "value": (_vm.bank)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bank = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item code"
  }, [_c('span', {
    staticClass: "item-name"
  }, [_vm._v("验证码:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请填写验证码"
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.isGetCode) ? _c('span', {
    staticClass: "get-code",
    on: {
      "click": _vm.getCode
    }
  }, [_vm._v("立即获取")]) : _vm._e(), _vm._v(" "), (_vm.isGetCode) ? _c('span', {
    staticClass: "sendCode"
  }, [_vm._v(_vm._s(_vm.time + ' s'))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "save-info"
  }, [_c('button', {
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保存")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-7e417b76","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/indexRouters/callAndReward/setWithdraw/setWithdraw.vue
// module id = 967
// module chunks = 1